import { ConnectWalletButton } from "../connect-wallet-button";
import images from "../../assets/images";
import { Theme, useTheme } from "../../context/theme";

export default function ChatEmptyScreen(props: {
  setInput: (str: string) => void;
}) {
  const { theme } = useTheme();
  return (
    <div className="max-w-5xl mx-auto p-4 text-center flex flex-col flex-1">
      <img
        src={theme === Theme.DARK ? images.SphereLogo : images.SphereLogoBlack}
        alt="Sphere logo"
        className="h-10 w-10 rounded-full mx-auto mb-2"
      />
      <h1 className="text-2xl text-gray-900 dark:text-gray-300">
        Welcome to Surface Area
      </h1>
      <p className="text-gray-900 dark:text-gray-400 mt-2">
        To get started, please connect your Wallet.
      </p>
      <div className="my-4 flex justify-center">
        <ConnectWalletButton />
      </div>
    </div>
  );
}
